<template>
  <div class="app__header">
    <header class="header">
      <router-link :to="homeRoute" class="header__logo-link">
        <svg class="header__logo" width="42" height="42">
          <use xlink:href="#normacs-logo" />
        </svg>
      </router-link>
      <template v-if="user.isAuthenticated">
        <search-form />
        <user-menu />
      </template>
    </header>
  </div>
</template>

<script>
import { ROUTE_HOME } from '@src/routes';

import SearchForm from './SearchForm';
import UserMenu from '@@/header/UserMenu';

export default {
  components: {
    SearchForm,
    UserMenu
  },

  data: () => ({
    homeRoute: {
      name: ROUTE_HOME
    }
  }),

  computed: {
    user() {
      return this.$store.state.auth.user;
    }
  }
};
</script>

<style src="./styles/index.css" />
